import { render, staticRenderFns } from "./VenueList.vue?vue&type=template&id=0b48b1fd&scoped=true&"
import script from "./VenueList.vue?vue&type=script&lang=js&"
export * from "./VenueList.vue?vue&type=script&lang=js&"
import style0 from "./VenueList.vue?vue&type=style&index=0&id=0b48b1fd&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b48b1fd",
  null
  
)

export default component.exports